/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import '../Style/Header.css';
import 'normalize.css';
import { Link } from 'react-router-dom';
import { ReactComponent as ProfileIcon } from '../img/ProfileIcon.svg';
import { ReactComponent as UnityIcon } from '../img/UnityIcon.svg';
import { ReactComponent as ContactIcon } from '../img/ContactIcon.svg';
import { ReactComponent as PortfolioIcon } from '../img/PortfolioIcon.svg';

const Header = ({
  title = 'My Website',
  eyebrow = '',
  extraActions = null,
  hiddenNavLabels = [],
}) => {
  const getSystemTheme = () => {
    if (typeof window === 'undefined') {
      return 'light';
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  };

  const [theme, setTheme] = useState(getSystemTheme);
  const navItems = [
    { label: 'Profile', path: '/', Icon: ProfileIcon },
    { label: 'Works', path: '/works', Icon: PortfolioIcon },
    { label: 'Avatar', path: '/avatar', Icon: UnityIcon },
    { label: 'Blog', path: '/blog' },
    { label: 'Mail', path: '/mail', Icon: ContactIcon },
  ];

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (event) => {
      setTheme(event.matches ? 'dark' : 'light');
    };

    setTheme(mediaQuery.matches ? 'dark' : 'light');
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  const toggleTheme = () => {
    setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <>
      <div className="header-spacer" />
      <header className="header-container">
        <h1 className="header-title">
          {eyebrow && <span>{eyebrow}</span>}
          {title}
        </h1>
        <nav className="header-nav">
          {navItems
            .filter(({ label }) => !hiddenNavLabels.includes(label))
            .map(({ label, path, Icon }) => (
              <Link
                key={path}
                to={path}
                className={`Btn ${Icon ? 'has-icon' : 'no-icon'}`}
              >
                {label}
                {Icon && <Icon className="svg" />}
              </Link>
            ))}
          {extraActions}
          <label className="switch theme-toggle" aria-label="Dark mode">
            <input
              type="checkbox"
              checked={theme === 'light'}
              onChange={toggleTheme}
            />
            <span className="slider" />
          </label>
        </nav>
      </header>
    </>
  );
};

export default Header;
